"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProxyFactoryAddress = exports.getDocumentStoreCreatorAddress = exports.PROXY_FACTORY_MAINNET = exports.PROXY_FACTORY_ROPSTEN = exports.DOCUMENT_STORE_CREATOR_MAINNET = exports.DOCUMENT_STORE_CREATOR_ROPSTEN = void 0;
const DOCUMENT_STORE_CREATOR_ROPSTEN = "0x4077534e82C97Be03A07FB10f5c853d2bC7161FB";
exports.DOCUMENT_STORE_CREATOR_ROPSTEN = DOCUMENT_STORE_CREATOR_ROPSTEN;
const DOCUMENT_STORE_CREATOR_MAINNET = "0x0";
exports.DOCUMENT_STORE_CREATOR_MAINNET = DOCUMENT_STORE_CREATOR_MAINNET;
const PROXY_FACTORY_ROPSTEN = "0xba2501bf20593f156879c17d38b6c245ca65de80";
exports.PROXY_FACTORY_ROPSTEN = PROXY_FACTORY_ROPSTEN;
const PROXY_FACTORY_MAINNET = "0x0";
exports.PROXY_FACTORY_MAINNET = PROXY_FACTORY_MAINNET;

const getDocumentStoreCreatorAddress = networkId => {
  if (networkId === 3) return DOCUMENT_STORE_CREATOR_ROPSTEN;
  return DOCUMENT_STORE_CREATOR_MAINNET;
};

exports.getDocumentStoreCreatorAddress = getDocumentStoreCreatorAddress;

const getProxyFactoryAddress = networkId => {
  if (networkId === 3) return PROXY_FACTORY_ROPSTEN;
  return PROXY_FACTORY_MAINNET;
};

exports.getProxyFactoryAddress = getProxyFactoryAddress;